import { useState } from "react";
import Input from "../../design/Input";
import regx from "../../../functions/regx";


function ContinerOffice({disable, office, name, permissions, onDubleClick, setMassageFetch, keyContiner, setDataFromServer}) {
    const [edit, setEdit] = useState(disable);
    const [data, setData] = useState({office: office, name: name, permissions: permissions});

    const heandelDClick = (event) => {
        event.stopPropagation();

        onDubleClick();
    }

    const resolveFromServer = (resolve) => {
        if (typeof resolve === 'object' && resolve !== null && resolve[0] === 'okay' && resolve['data']) {
            setMassageFetch({text: resolve['data'], open: true});

        } else {
            setMassageFetch({text: "שגיאה", open: true});
        }
    }

    const clickSave = () => {
        if (regx(`^[0-9]{7}$`, data.office, false) && regx('strEnHe', data.name, false)) {

            setMassageFetch(
                {text: "", data: {...data, num: keyContiner}, url: "adminUsers/save-office", open: true, fun: resolveFromServer}
            )
        }
    }

    const clickDelete = () => {
        setMassageFetch(
            {text: "", data: {num: keyContiner}, url: "adminUsers/delete-office", open: true, fun: resolveFromServer}
        )
    }


    return (
        <div className={"OfficeAndWorkerContiner"} onMouseLeave={() => setEdit(true)} onDoubleClick={heandelDClick}>
            <p>מס' משרד</p>
            <Input
            disable={edit}
            value={data.office}
            onChange={(v) => setData({...data, office: v})}
            pattern={`^[0-9]{7}$`}
            />

            <p>שם</p>
            <Input
            disable={edit}
            value={data.name}
            onChange={(v) => setData({...data, name: v})}
            pattern={'strEnHe'}
            />

            <p>הרשאות</p>

            <select value={data.permissions} onChange={(e) => setData({...data, permissions: e.target.value})} disabled={edit}>
                <option value={'b'}>הרשאות רגילות</option>
                <option value={'a'}>הרשאות מנהל</option>
            </select>

            <div className={"OfficeAndWorkerContinerEnd"}>
                <p onClick={() => setEdit(false)}>עדכון</p>
                <p onClick={clickDelete}>מחיקה</p>
            </div>

            <p onClick={clickSave}>שמירה</p>

        </div>
    )
}


export default ContinerOffice;